import { memo } from 'react';

import DocumentIconSVG from '@/assets/document-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDocumentIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DocumentIconSVG} {...props} />;

export const DocumentIcon = memo(IDocumentIcon) as typeof IDocumentIcon;
